export default __webpack_public_path__ + "static/media/facebook.ee015e95.svg";